import { Component, Input } from '@angular/core';

@Component({
  selector: 'hint-modal',
  templateUrl: './hint-modal.component.html',
  styleUrls: ['./hint-modal.component.scss']
})
export class HintModalComponent {

  @Input() title: string = '';
  @Input() content: string = '';

}
